import React, { useState, useEffect, useMemo } from "react";
import Card from "../../components/Card";
import { useNavigate } from "react-router-dom";
import { Row, Col, OverlayTrigger, Tooltip, Button } from 'react-bootstrap'
import { FaEdit } from "react-icons/fa";
import RegistrasiService from "../../services/registrasi/RegistrasiService";
import DataTable from "react-data-table-component";

//progressbar
// import Progress from "../../../components/progress.js";

const Traders = () => {
  let RegService = useMemo(() => new RegistrasiService(), []);
  const [traders, setTraders] = useState([]);
  const [filterRecord, setFilterRecord] = useState([])

  const navigate = useNavigate();

  const EditTRader = (kdTrader) => {
    localStorage.removeItem('editTraderStorage')
    localStorage.setItem('editTraderStorage', kdTrader)
    navigate('/setting/edit-trader')
  }

  const columns = [
    {
      name: "KODE TRADER",
      selector: row => row.KODE_TRADER,
    },
    {
      name: "NAMA",
      selector: row => row.NAMA,
    },
    {
      name: "NPWP",
      selector: row => row.NPWP,
    },
    {
      name: "EMAIL",
      selector: row => row.EMAIL,
    },
    {
      name: "TELEPON",
      selector: row => row.TELEPON,
    },
    {
      name: "NAM USER",
      selector: row => row.tb_users[0].NAMA,
    },
    // {
    //   name: "PENANGGUNGJAWAB",
    //   selector: row => row.tb_users[0].NAMA,
    // },
    {
      name: "ACTION",
      cell: row => <div className="flex align-items-center list-user-action">
        <div className="col-sm-4">
          <OverlayTrigger placement="bottom" overlay={
            <Tooltip >Edit Trader</Tooltip>
          }>
            <Button size="sm" variant="warning" onClick={() => EditTRader(row.KODE_TRADER)}>
              <FaEdit />
            </Button>
          </OverlayTrigger>
        </div>
        {/* <Link className="btn btn-sm btn-icon btn-danger" data-toggle="tooltip" data-placement="top" title="Delete" data-original-title="Delete" to="#">
          <span className="btn-inner">
            <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor">
              <path d="M19.3248 9.46826C19.3248 9.46826 18.7818 16.2033 18.4668 19.0403C18.3168 20.3953 17.4798 21.1893 16.1088 21.2143C13.4998 21.2613 10.8878 21.2643 8.27979 21.2093C6.96079 21.1823 6.13779 20.3783 5.99079 19.0473C5.67379 16.1853 5.13379 9.46826 5.13379 9.46826" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
              <path d="M20.708 6.23975H3.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
              <path d="M17.4406 6.23973C16.6556 6.23973 15.9796 5.68473 15.8256 4.91573L15.5826 3.69973C15.4326 3.13873 14.9246 2.75073 14.3456 2.75073H10.1126C9.53358 2.75073 9.02558 3.13873 8.87558 3.69973L8.63258 4.91573C8.47858 5.68473 7.80258 6.23973 7.01758 6.23973" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
            </svg>
          </span>
        </Link>{' '} */}
      </div>,
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    }
  ];

  useEffect(() => {
    getTraders();
  },[]);

  useEffect(() => {
    let roleUser = localStorage.getItem('role')
    if(roleUser !== "1" && roleUser !== "2"){
      navigate('/dashboard')
    }
  },[navigate]);

  const getTraders = async () => {
    const response = await RegService.getAllTrader()
    setTraders(response.data);
    setFilterRecord(response.data)
  };

  const handleFilter = (event) => {
    console.log(event.target.value) 
    const newData = filterRecord.filter(row => row["NAMA"].toLowerCase().includes(event.target.value.toLowerCase()))
    setTraders(newData)
  }

  return (
    <>
      <Row>
        <Col sm="12">
          <Card>
            <Card.Header d-flex justify-content-between>
              <Row>
                <Col sm="6">
                  <div className="header-title">
                    <h4 className="card-title">Daftar Trader</h4>
                  </div>
                </Col>
                <Col sm="6">
                  <div className="input-group search-input">
                    <span className="input-group-text" id="search-input">
                      <svg width="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="11.7669" cy="11.7666" r="8.98856" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></circle>
                        <path d="M18.0186 18.4851L21.5426 22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                      </svg>
                    </span>
                    <input
                      type="search"
                      className="form-control"
                      placeholder="Search..."
                      onChange={handleFilter}
                    />
                  </div>
                </Col>
              </Row>
            </Card.Header>
            <Card.Body>
              <DataTable
                columns={columns}
                data={traders}
                pagination
              />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default Traders;
